import React from 'react';
import PropTypes from 'prop-types';

import { formHelpers } from '../index';

import Countries from '@module/i18n/countries';
import I18n from '@module/i18n';

import AutoComplete from '@component/form/element/autocomplete';
import FormNotification from '@component/form/element/formnotification';

const CountryField = ({
  value,
  defaultValue,
  errorMessage,
  updateValue,
  variant,
}) => {
  const country = formHelpers.getCountryByCode(value || defaultValue);

  const onChange = async (value) => {
    const country = formHelpers.getCountryByName(value);
    if (country) {
      await updateValue('country_code', country.id, true);
    } else {
      updateValue('country_code', '', true);
    }
  };

  return (
    <div>
      <AutoComplete
        data={Countries}
        label={I18n.t('form.account.label.country_code')}
        name="country_code"
        defaultValue={(country && country.label) || ''}
        onChange={onChange}
        valid={0}
        variant={variant}
      />
      <FormNotification message={errorMessage} type="error" />
    </div>
  );
};

CountryField.propTypes = {
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  errorMessage: PropTypes.string,
  updateValue: PropTypes.func.isRequired,
  variant: PropTypes.string,
};

CountryField.defaultProps = {
  value: '',
  variant: 'default',
};

export default CountryField;
